import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-711a4fb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shape-pool" }
const _hoisted_2 = { class: "category-name" }
const _hoisted_3 = { class: "shape-list" }

import { SHAPE_LIST, ShapePoolItem } from '@/configs/shapes'
import ShapeItemThumbnail from './ShapeItemThumbnail.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShapePool',
  emits: ["select"],
  setup(__props, { emit }: { emit: ({
  (event: 'select', payload: ShapePoolItem): void
}), expose: any, slots: any, attrs: any }) {



const selectShape = (shape: ShapePoolItem) => {
  emit('select', shape)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SHAPE_LIST), (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "category",
        key: item.type
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(item.type), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (shape, index) => {
            return (_openBlock(), _createBlock(ShapeItemThumbnail, {
              class: "shape-item",
              key: index,
              shape: shape,
              onClick: ($event: any) => (selectShape(shape))
            }, null, 8, ["shape", "onClick"]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}
}

})